import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const ITEMS = [
  {
    q: "Do I need sales experience to apply?",
    a: "No. We hire for attitude and coachability. Our two-week field training will turn you into a closer — even if you've never sold before.",
  },
  {
    q: "Is this really 100% commission?",
    a: "Yes. There's no salary, but there's also no cap. Top reps earn far more on commission than they ever would on a salary.",
  },
  {
    q: "Which territories are open?",
    a: "We operate across multiple Canadian Provinces and Territories with new markets opening monthly. When you call, a recruiter will let you know which territories are actively hiring near you.",
  },
  {
    q: "What hours will I work?",
    a: "Door-to-door is most effective in afternoons and early evenings (roughly 1 PM – 8 PM). You set your own schedule — full-time, part-time, or weekends only.",
  },
  {
    q: "What does Knockwave actually sell?",
    a: "We sell residential telecom services (internet, TV, and home phone) on behalf of a leading nationwide telecom provider. We're an authorized retail partner.",
  },
  {
    q: "How do I get paid?",
    a: "Commissions are paid bi-weekly to the rep.",
  },
  {
    q: "Is there room to grow into leadership?",
    a: "Absolutely. Every Knockwave manager started as a rep. Hit your numbers and you'll be invited into Team Lead, Regional Manager, and Market Director tracks.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-slate-50 border-t border-slate-200"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="mb-12">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-blue-600 mb-4">
            FAQ
          </p>
          <h2 className="font-heading text-4xl md:text-5xl tracking-tight font-bold text-slate-900">
            Questions reps ask before joining.
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="bg-white border border-slate-200"
          data-testid="faq-accordion"
        >
          {ITEMS.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="border-b border-slate-200 last:border-b-0"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${idx}`}
                className="px-6 py-5 text-left font-heading text-base md:text-lg font-semibold text-slate-900 hover:no-underline hover:bg-slate-50"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${idx}`}
                className="px-6 pb-5 text-base text-slate-600 leading-relaxed"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
